import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from 'src/toolkit/services/AuthProvider';
import routerPaths from 'src/integration/config/routerPaths';

const PublicRoute = () => {
  const { token } = useAuth();

  if (token) return <Navigate to={routerPaths.home()} />;
  return <Outlet />;
};

export default PublicRoute;